export class InvalidMembershipCurrencyError extends Error {
  constructor(currencyCode: string) {
    super(
      `This booking is marked as a membership booking, but no rate for the selected hotel's currency (${currencyCode}) is available`
    );
  }
}
